import React from 'react';
import { getGetGpsIntegrationsQueryOptions } from '@area-restrita/api-client/endpoints/gps-integrations/gps-integrations.gen';

import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';
import { useQueryTable } from '@/hooks/useQueryTable';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import DataGrid from '@/components/DataGrid';

import { columns } from './columns';
import CreateGpsIntegrationModal from './components/CreateGpsIntegrationModal';

const GpsIntegrations: React.FC = () => {
  const { checkAuthorization } = useAuthSessionStore();

  const {
    table,
    query: { isLoading },
  } = useQueryTable({
    columns,
    getQueryOptions: ({ page, limit }) =>
      getGetGpsIntegrationsQueryOptions({ page, limit }),
  });

  const canCreate = checkAuthorization(
    ({ can }) => can('create', 'departments'), // TODO: Atualizar quando a permissão gps_integrations estiver disponível
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Integrações GPS</CardTitle>
        <CardDescription>
          Gerencie as integrações GPS para rastreamento de veículos.
        </CardDescription>
      </CardHeader>

      <CardContent className="p-0">
        <DataGrid
          table={table}
          isLoading={isLoading}
          actions={
            canCreate ? (
              <CreateGpsIntegrationModal
                trigger={<Button size="sm">Nova integração</Button>}
              />
            ) : null
          }
          onRowClick={(integration) => {
            // TODO: Implementar navegação para detalhes quando a rota estiver criada
            console.log('Clicked integration:', integration);
          }}
        />
      </CardContent>
    </Card>
  );
};

export default GpsIntegrations;
